import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';

import Button from './Button';
import titleImg from '../images/home-1.svg';
import centerImg from '../images/home-2.svg';

class Home extends Component {
  constructor() {
    super();

    this.activateButton = this.activateButton.bind(this);
    this.deactivateButton = this.deactivateButton.bind(this);

    this.state = {
      isButtonActive: false
    };
  }

  activateButton() {
    this.setState({
      isButtonActive: true
    });
  }

  deactivateButton() {
    this.setState({
      isButtonActive: false
    });
  }

  render() {
    return (
      <div className="container mobile-center-adj vertical-horizontal-center full-width">
        <div className="row">
          <div className="col-xs-10 col-xs-offset-1 col-sm-6 col-sm-offset-3 col-md-4 col-md-offset-4 text-center">
            <img
              src={titleImg}
              className="img-responsive img-xs-title"
              alt="然後，錢包就死掉了"
            />
          </div>
        </div>
        <div className="row margin-top-xl">
          <div className="col-xs-10 col-xs-offset-1 col-sm-6 col-sm-offset-3 col-md-4 col-md-offset-4 text-center">
            <img
              src={centerImg}
              className="img-responsive"
              alt="Fainting figure"
            />
          </div>
        </div>
        <div className="row margin-top-home">
          <div className="col-xs-10 col-xs-offset-1 col-sm-6 col-sm-offset-3 col-md-4 col-md-offset-4 text-center">
            <div className="dialog padding-sm padding-no">
              <h4 className="margin-no">
                錢包怎麼了？它為什麼死了？它怎麼死的？
              </h4>
            </div>
          </div>
        </div>
        <div className="row margin-top-lg margin-bottom-lg">
          <div className="col-xs-10 col-xs-offset-1 col-sm-6 col-sm-offset-3 col-md-4 col-md-offset-4 text-center">
            <Link
              to="/explanation"
            >
              <Button
                className={classNames(
                  'btn',
                  'btn-default'
                )}
              >
                一起來破案
              </Button>
            </Link>
          </div>
        </div>
      </div>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./app/components/Home.js